import { useEffect, useState } from "react";
import { Phone, MessageSquare } from "lucide-react";
import { CONTACT } from "@/data/site";

// Floating Call + Estimate buttons visible on mobile only. Hides itself when
// the contact form is in view so it doesn't duplicate the primary CTA.
export default function StickyMobileCTA() {
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    if (typeof IntersectionObserver === "undefined") return undefined;
    const target = document.querySelector("#contact");
    if (!target) return undefined;
    const io = new IntersectionObserver(
      (entries) => entries.forEach((e) => setHidden(e.isIntersecting)),
      { threshold: 0.15 }
    );
    io.observe(target);
    return () => io.disconnect();
  }, []);

  return (
    <div
      data-testid="sticky-mobile-cta"
      aria-hidden={hidden}
      className={`md:hidden fixed bottom-4 inset-x-4 z-[55] transition-all duration-300 ${
        hidden ? "opacity-0 pointer-events-none translate-y-6" : "opacity-100"
      }`}
    >
      <div className="flex gap-2.5 rounded-full bg-[#0A192F]/95 backdrop-blur border border-white/10 p-1.5 shadow-[0_14px_40px_-10px_rgba(0,0,0,0.5)]">
        <a
          href={`tel:${CONTACT.phoneRaw}`}
          data-testid="sticky-call-cta"
          className="flex-1 inline-flex items-center justify-center gap-2 rounded-full bg-white/10 text-white font-semibold text-sm py-3.5 active:scale-[0.98] transition-transform"
        >
          <Phone className="h-4 w-4 text-[#F97316]" />
          Call
        </a>
        <a
          href="#contact"
          data-testid="sticky-estimate-cta"
          className="flex-1 inline-flex items-center justify-center gap-2 rounded-full bg-[#F97316] text-white font-semibold text-sm py-3.5 active:scale-[0.98] transition-transform"
        >
          <MessageSquare className="h-4 w-4" />
          Get Estimate
        </a>
      </div>
    </div>
  );
}
